import React, { Component } from "react";
import welcome from './welcome.png';
import enter from './enter.png';
import enterhover from './enter-hover.png';
import HoverImage from "react-hover-image"


import './welcome.css';

class Welcome extends Component {
  render() {
    return (
        <div className="welcome">
          <img src={welcome} className="App-welcome" alt="welcome" />
        <div className="enter">
          <a href="http://www.ukvac.com/forum">
          <HoverImage
          src={enter}
          hoverSrc={enterhover}
        />
          </a>
        </div>
        </div>

    );
  }
}
 
export default Welcome;



// WEBPACK FOOTER //
// ./src/Welcome.js